<div class="date-filter-container mb-0">
    <div class="date-filter-header">
        <div class="date-nav-with-label">
            <button type="button" class="btn date-nav-btn" (click)="decrementDate()" rippleEffect>
                <i data-feather="chevron-left"></i>
            </button>
            <button type="button" class="btn date-nav-btn" (click)="incrementDate()" rippleEffect>
                <i data-feather="chevron-right"></i>
            </button>
            <p class="date-display">{{ selectedPeriod || '' }}</p>
        </div>
    </div>
    <div class="date-filter-buttons">
        <div class="btn-group" role="group">
            <button type="button" class="btn bouttons" rippleEffect (click)="changeViewMode('jours');"
                    [class.active]="viewMode==='jours'">
                <p>Jours</p>
            </button>
            <button type="button" class="btn bouttons" rippleEffect (click)="changeViewMode('mois');"
                    [class.active]="viewMode==='mois'">
                <p>Mois</p>
            </button>
            <button type="button" class="btn bouttons" rippleEffect (click)="changeViewMode('annees');"
                    [class.active]="viewMode==='annees'">
                <p>Année</p>
            </button>
            <button class="btn bouttons" rippleEffect (click)="openFlatpickr(); $event.preventDefault()"
                    style="color: rgba(19, 74, 211, 1);">
                <i data-feather="calendar"></i>
            </button>
        </div>
        <input type="text" #datePicker class="flatpickr-input" style="margin-top: 40px;"/>
    </div>
</div>

<div class="data-list mb-0 p-0" *ngIf="viewMode === 'jours'">
    <div class="data-list-wrapper">
        <div *ngFor="let day of weekDays"
             (click)="selectDay(day)"
             [class.selected]="day.dateString === selectedDay"
             [class.today]="day.isToday"
             class="day-item">
            {{ day.label }}
        </div>
    </div>
</div>

<div class="data-list mb-0 p-0" *ngIf="viewMode === 'mois'">
    <div class="data-list-wrapper">
        <div *ngFor="let month of months; let i=index"
             (click)="selectMonth(i)"
             [class.selected]="i === selectedMonthIndex"
             [class.today]="i === currentMonthIndex"
             class="month-item">
            {{ month }}
        </div>
    </div>
</div>

<div class="data-list mb-0 p-0" *ngIf="viewMode === 'annees'">
    <div class="data-list-wrapper">
        <div *ngFor="let year of years"
             (click)="selectYear(year)"
             [class.selected]="year === selectedYear"
             [class.today]="year === currentYear"
             class="year-item">
            {{ year }}
        </div>
    </div>
</div>

<app-document-list-progress></app-document-list-progress>

<div class="global-header d-flex flex-column border-bottom rounded justify-content-center"
     style="height: 160px; padding: 24px; margin-top: 24px; background: rgba(247, 250, 255, 1); position: relative;"
     *ngIf="type === 'facture' || type === 'bon-livraison' || type === 'facture-fournisseur' ">

    <!-- Bouton "Cliquez pour charger" – s'affiche pour les 3 types tant que le blur n'est pas retiré -->
    <div *ngIf="!isBlurRemoved" class="load-button-container">
        <button type="button" class="btn btn-primary load-button" (click)="removeBlur()">
            Cliquez pour charger
        </button>
    </div>

    <!-- Contenu flouté tant qu'on n'a pas cliqué -->
    <div class="content-to-blur" [ngClass]="{'blurred': !isBlurRemoved}">
        <div class="d-flex justify-content-between gap-2 p-0">
            <!-- Bloc 1 : Total -->
            <div class="d-flex align-items-center flex-grow-1" style="width: 100%; max-width: 200px; height: 76px">
                <button type="button" class="facture-total-button justify-content-center">
                    <a target="_blank" title="Total">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                             class="bi bi-stack" viewBox="0 0 16 16">
                            <path d="m14.12 10.163 1.715.858c.22.11.22.424 0 .534L8.267 15.34a.6.6 0 0 1-.534 0L.165 11.555a.299.299 0 0 1 0-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0l5.317-2.66zM7.733.063a.6.6 0 0 1 .534 0l7.568 3.784a.3.3 0 0 1 0 .535L8.267 8.165a.6.6 0 0 1-.534 0L.165 4.382a.299.299 0 0 1 0-.535z"/>
                            <path d="m14.12 6.576 1.715.858c.22.11.22.424 0 .534l-7.568 3.784a.6.6 0 0 1-.534 0L.165 7.968a.299.299 0 0 1 0-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0z"/>
                        </svg>
                    </a>
                </button>
                <div class="d-flex flex-column" style="margin-left: 16px">
                    <span class="total">Total</span>
                    <span class="phone-number d-flex">
                        <p class="style18">{{ (type === 'facture' && statsFacturesGlobales?.data) ? (statsFacturesGlobales.data.total_ttc | number:'1.3-3') : (type === 'facture-fournisseur' && statsFacturesFournisseurGlobales?.data) ? (statsFacturesFournisseurGlobales.data.total_ttc | number:'1.3-3') : (totalFactureTTC | number:'1.3-3') }} </p>
                        <p class="style15"> TND </p>
                        <p class="style18"> TTC </p>
                    </span>
                    <span class="phone-number d-flex">
                        <p class="style18">{{ (type === 'facture' && statsFacturesGlobales?.data) ? (statsFacturesGlobales.data.total_ht | number:'1.3-3') : (type === 'facture-fournisseur' && statsFacturesFournisseurGlobales?.data) ? (statsFacturesFournisseurGlobales.data.total_ht | number:'1.3-3') : (totalFactureHTC | number:'1.3-3') }} </p>
                        <p class="style15"> TND </p>
                        <p class="style18"> HT </p>
                    </span>
                </div>
            </div>

            <!-- Bloc 2 : Factures payées -->
            <div class="d-flex align-items-center flex-grow-1" style="width: 100%; max-width: 200px; height: 76px">
                <button type="button" class="facture-paye-button m-0 justify-content-center">
                    <a target="_blank" title="Factures payées">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                             class="bi bi-file-earmark-check" viewBox="0 0 16 16">
                            <path d="M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z"/>
                            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                        </svg>
                    </a>
                </button>
                <div class="d-flex flex-column" style="margin-left: 16px">
                    <span class="total">Factures payées</span>
                    <div class="phone-number d-flex">
                        <p class="style18">{{ (type === 'facture' && statsFacturesGlobales?.data) ? (statsFacturesGlobales.data.factures_payees.total_ttc | number:'1.3-3') : (type === 'facture-fournisseur' && statsFacturesFournisseurGlobales?.data) ? (statsFacturesFournisseurGlobales.data.factures_payees.total_ttc | number:'1.3-3') : (totalFacturePaye | number:'1.3-3') }} </p>
                        <p class="style15"> TND </p>
                        <p class="style18"> TTC </p>
                    </div>
                    <span *ngIf="type === 'facture' && statsFacturesGlobales?.data" class="small text-muted">{{ statsFacturesGlobales.data.factures_payees.nombre }} facture(s)</span>
                    <span *ngIf="type === 'facture-fournisseur' && statsFacturesFournisseurGlobales?.data" class="small text-muted">{{ statsFacturesFournisseurGlobales.data.factures_payees.nombre }} facture(s)</span>
                </div>
            </div>

            <!-- Bloc 3 : Factures à payer -->
            <div class="d-flex align-items-center flex-grow-1" style="width: 100%; max-width: 200px; height: 76px">
                <button type="button" class="facture-a-paye-button m-0 justify-content-center">
                    <a target="_blank" title="Factures à payer">
                        <span data-feather="file-minus" [size]="24"></span>
                    </a>
                </button>
                <div class="d-flex flex-column" style="margin-left: 16px">
                    <span class="total">Factures à payer</span>
                    <div class="phone-number d-flex">
                        <p class="style18">{{ (type === 'facture' && statsFacturesGlobales?.data) ? (facturesAPayerTotalTTC | number:'1.3-3') : (type === 'facture-fournisseur' && statsFacturesFournisseurGlobales?.data) ? (facturesFournisseurAPayerTotalTTC | number:'1.3-3') : (totalFactureAPaye | number:'1.3-3') }} </p>
                        <p class="style15"> TND </p>
                        <p class="style18"> TTC </p>
                    </div>
                    <span *ngIf="type === 'facture' && statsFacturesGlobales?.data" class="small text-muted">{{ statsFacturesGlobales.data.factures_a_payer.nombre }} facture(s)</span>
                    <span *ngIf="type === 'facture-fournisseur' && statsFacturesFournisseurGlobales?.data" class="small text-muted">{{ statsFacturesFournisseurGlobales.data.factures_a_payer.nombre }} facture(s)</span>
                </div>
            </div>

            <!-- Bloc 4 : Factures en retard -->
            <div class="d-flex align-items-center" style="width: 100%; max-width: 222px; height: 76px">
                <button type="button" class="facture-retard-button p-0 m-0 justify-content-center">
                    <a target="_blank" title="Factures en retard">
                        <span data-feather="alert-circle" [size]="24"></span>
                    </a>
                </button>
                <div class="d-flex flex-column" style="margin-left: 16px">
                    <span class="total">En retard</span>
                    <div class="phone-number d-flex">
                        <p class="style18">{{ (type === 'facture' && statsFacturesGlobales?.data) ? (0 | number:'1.3-3') : (type === 'facture-fournisseur' && statsFacturesFournisseurGlobales?.data) ? (0 | number:'1.3-3') : (totalFactureRetard | number:'1.3-3') }} </p>
                        <p class="style15"> TND </p>
                        <p class="style18"> TTC </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="d-flex" style="position: relative;">
    <div class="card-body row m-0" style="padding: 24px">
        <div class="input-group form-password-toggle d-flex" style="width: 300px;">
            <input
                    type="text"
                    class="form-control"
                    placeholder="Recherche par mot clé"
                    aria-label="Search..."
                    aria-describedby="basic-addon-search1"
                    [(ngModel)]="searchTerm"
                    (ngModelChange)="onSearch()"
            />
            <div class="input-group-append" style="margin-right: 10px;">
                <span class="input-group-text" id="basic-addon-search1" style="color: black;">
                    <i data-feather="search" [size]="20"></i>
                </span>
            </div>
        </div>
        <button type="button" class="btn btn-outline-primary btn-icon" (click)="toggleFilter()" STYLE="padding: 10px 11px !important;">
            <span data-feather="filter"></span>
        </button>

        <!-- Badges de filtres actifs -->
        <div class="active-filters-container d-flex flex-wrap align-items-center gap-2" style="margin-left: 12px;" *ngIf="getActiveFilters().length > 0">
            <div *ngFor="let filter of getActiveFilters(); trackBy: trackByFilterKey" class="filter-badge">
                <span class="filter-badge-label">{{ filter.label }}:</span>
                <span class="filter-badge-value">{{ filter.value }}</span>
                <button type="button" class="filter-badge-close" (click)="removeFilter(filter.key, $event); $event.stopPropagation(); $event.preventDefault()" aria-label="Supprimer le filtre">
                    <i data-feather="x" style="width: 12px; height: 12px;"></i>
                </button>
            </div>
        </div>

        <div class="col-auto ms-auto p-0" style="margin-left: auto;" *ngIf="type !== 'avoir' && type !== 'avoir-fournisseur'">
            <button type="button" class="btn btn-primary mt-0" [routerLink]="getAddRoute()">
                <span data-feather="plus" style="color: white;"></span> Ajouter
            </button>
        </div>
    </div>

    <!-- Panneau de filtres pour Vente -->
    <div #filterPanelVente class="card filter-sidebar length" *ngIf="showFilter && baseRoute === '/vente'"
         style="width: 380px; max-height: 460px; box-shadow: 0 4px 18px rgba(47, 43, 61, 0.16);">
        <div class="card-header d-flex justify-content-between align-items-center" style="margin-top: 2px;">
            <h4 class="card-title mb-0">Filtres</h4>
            <button class="btn btn-sm btn-icon btn-light" (click)="toggleFilter()" aria-label="X">
                X <i class="bx bx-x"></i>
            </button>
        </div>
        <div class="card-body d-flex flex-column p-1" style="height: 545px">
            <div class="flex-grow-1 overflow-auto pe-1">
                <div class="mb-1" *ngIf="!isClientDetailsDocumentScope">
                    <label class="form-label">Client</label>
                    <div class="d-flex w-100">
                        <ng-select 
                            id="clientSelect"
                            class="filter-ng-select flex-grow-1"
                            [items]="clients"
                            [searchable]="true"
                            [clearable]="true"

                            placeholder="Choisissez un client"
                            [(ngModel)]="filters.client_id"
                            (change)="updateFilteredData()"
                            bindValue="id">
                            <ng-template ng-option-tmp let-item="item">
                                {{ item.nom_prenom || item.nom_client || item.raison_sociale || '--' }}
                            </ng-template>
                            <ng-template ng-label-tmp let-item="item">
                                {{ item?.nom_prenom || item?.nom_client || item?.raison_sociale || 'Choisissez un client' }}
                            </ng-template>
                        </ng-select>
                    </div>
                </div>

                <div class="mb-1">
                    <label class="form-label">Projet</label>
                    <div class="d-flex w-100">
                        <ng-select
                            id="projetSelectVente"
                            class="filter-ng-select flex-grow-1"
                            [items]="projects"
                            [searchable]="true"
                            [clearable]="true"
                            [loading]="isLoadingProjects"
                            placeholder="Choisissez un projet"
                            [(ngModel)]="filters.projet_id"
                            (change)="onProjetFilterChange()"
                            bindValue="id">
                            <ng-template ng-option-tmp let-item="item">
                                {{ item.libelle || item.titre || '--' }}
                            </ng-template>
                            <ng-template ng-label-tmp let-item="item">
                                {{ item?.libelle || item?.titre || 'Choisissez un projet' }}
                            </ng-template>
                        </ng-select>
                    </div>
                </div>

                <div class="mb-1">
                    <label class="form-label">Montant</label>
                    <div class="d-flex w-100">
                        <select class="form-select form-control flex-grow-1" [(ngModel)]="filters.operator">
                            <option value="=">=</option>
                            <option value=">">></option>
                            <option value="<"><</option>
                        </select>
                        <input type="number" class="form-control flex-grow-1" [(ngModel)]="filters.chiffre_aff"
                               style="margin-left: 12px;"/>
                    </div>
                </div>
                <div>
                    <label class="form-label" style="margin-bottom: 8px">État</label>
                    <br>
                    <div *ngFor="let etat of statuses" 
                         class="containerType" 
                         [class.selected]="isStatusSelected(etat)"
                         (click)="toggleStatusFilter(etat)"
                         style="cursor: pointer;">
                        {{ etat }}
                    </div>
                </div>
                <div class="mb-1 filter-date-container">
                    <div class="d-flex w-100" style="gap: 12px;">
                        <div class="flex-grow-1">
                            <label for="dateDuVente" class="form-label">Date de création</label>
                            <input #dateDuVente id="dateDuVente" type="text" class="form-control m-0" placeholder="du" 
                                   readonly
                                   style="cursor: pointer; background-color: white;"/>
                        </div>
                        <div class="flex-grow-1">
                            <label for="dateJusquaVente" class="form-label">Jusqu'à</label>
                            <input #dateJusquaVente id="dateJusquaVente" type="text" placeholder="Jusqu'à" 
                                   class="form-control m-0" 
                                   readonly
                                   style="cursor: pointer; background-color: white;"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pt-2 d-flex justify-content-end gap-1">
                <button class="btn btn-outline-secondary" (click)="resetFilters()" style="margin-right: 15px;">
                    Réinitialiser
                </button>
                <button class="btn btn-primary" (click)="applyFilters()">Appliquer</button>
            </div>
        </div>
    </div>

    <!-- Panneau de filtres pour Achat -->
    <div #filterPanelAchat class="card filter-sidebar length" *ngIf="showFilter && baseRoute === '/achat'"
         style="width: 380px; max-height: 460px;  box-shadow: 0 4px 18px rgba(47, 43, 61, 0.16);">
        <div class="card-header d-flex justify-content-between align-items-center" style="margin-top: 2px;">
            <h4 class="card-title mb-0">Filtres</h4>
            <button class="btn btn-sm btn-icon btn-light" (click)="toggleFilter()" aria-label="X">
                X <i class="bx bx-x"></i>
            </button>
        </div>
        <div class="card-body d-flex flex-column p-1" style="height: 545px">
            <div class="flex-grow-1 overflow-auto pe-1">
                <div class="mb-1">
                    <label class="form-label">Fournisseur</label>
                    <div class="d-flex w-100">
                        <ng-select 
                            id="fournisseurSelect"
                            class="filter-ng-select flex-grow-1"
                            [items]="fournisseurs"
                            [searchable]="true"
                            [clearable]="true"
                            placeholder="Choisissez un fournisseur"
                            [(ngModel)]="filters.fournisseur_id"
                            (change)="updateFilteredData()"
                            bindValue="id">
                            <ng-template ng-option-tmp let-item="item">
                                {{ item.nom_entreprise || '--' }}
                            </ng-template>
                            <ng-template ng-label-tmp let-item="item">
                                {{ item?.nom_entreprise || 'Choisissez un fournisseur' }}
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
                <div class="mb-1">
                    <label class="form-label">Projet</label>
                    <div class="d-flex w-100">
                        <ng-select
                            id="projetSelectAchat"
                            class="filter-ng-select flex-grow-1"
                            [items]="projects"
                            [searchable]="true"
                            [clearable]="true"
                            [loading]="isLoadingProjects"
                            placeholder="Choisissez un projet"
                            [(ngModel)]="filters.projet_id"
                            (change)="onProjetFilterChange()"
                            bindValue="id">
                            <ng-template ng-option-tmp let-item="item">
                                {{ item.libelle || item.titre || '--' }}
                            </ng-template>
                            <ng-template ng-label-tmp let-item="item">
                                {{ item?.libelle || item?.titre || 'Choisissez un projet' }}
                            </ng-template>
                        </ng-select>
                    </div>
                </div>


                <div class="mb-1">
                    <label class="form-label">Montant</label>
                    <div class="d-flex w-100">
                        <select class="form-select form-control flex-grow-1" [(ngModel)]="filters.operator">
                            <option value="=">=</option>
                            <option value=">">></option>
                            <option value="<"><</option>
                        </select>
                        <input type="number" class="form-control flex-grow-1" [(ngModel)]="filters.chiffre_aff"
                               style="margin-left: 12px;"/>
                    </div>
                </div>
                <div >
                    <label class="form-label" style="margin-bottom: 8px">État</label>
                    <br>
                    <div *ngFor="let etat of statuses" 
                         class="containerType" 
                         [class.selected]="isStatusSelected(etat)"
                         (click)="toggleStatusFilter(etat)"
                         style="cursor: pointer;">
                        {{ etat }}
                    </div>
                </div>
                <div class="mb-1 filter-date-container">
                    <div class="d-flex w-100" style="gap: 12px;">
                        <div class="flex-grow-1">
                            <label for="dateDuAchat" class="form-label">Date de création</label>
                            <input #dateDuAchat id="dateDuAchat" type="text" class="form-control m-0" placeholder="du" 
                                   readonly
                                   style="cursor: pointer; background-color: white;"/>
                        </div>
                        <div class="flex-grow-1">
                            <label for="dateJusquaAchat" class="form-label">Jusqu'à</label>
                            <input #dateJusquaAchat id="dateJusquaAchat" type="text" placeholder="Jusqu'à" 
                                   class="form-control m-0" 
                                   readonly
                                   style="cursor: pointer; background-color: white;"/>
                        </div>
                    </div>
                </div>

            </div>
            <div class="pt-2 d-flex justify-content-end gap-1">
                <button class="btn btn-outline-secondary" (click)="resetFilters()" style="margin-right: 15px;">
                    Réinitialiser
                </button>
                <button class="btn btn-primary" (click)="applyFilters()">Appliquer</button>
            </div>
        </div>
    </div>

    <!-- Panneau de filtres pour Stock (Inventaire et Bon Transfert) -->
    <div #filterPanelStock class="card filter-sidebar length" *ngIf="showFilter && baseRoute === '/stock'"
         style="width: 380px; max-height: 460px; box-shadow: 0 4px 18px rgba(47, 43, 61, 0.16);">
        <div class="card-header d-flex justify-content-between align-items-center" style="margin-top: 2px;">
            <h4 class="card-title mb-0">Filtres</h4>
            <button class="btn btn-sm btn-icon btn-light" (click)="toggleFilter()" aria-label="X">
                X <i class="bx bx-x"></i>
            </button>
        </div>
        <div class="card-body d-flex flex-column p-1" style="height: 545px">
            <div class="flex-grow-1 overflow-auto pe-1">
                <!-- Entrepôt (uniquement pour inventaire) -->
                <div class="mb-1" *ngIf="type === 'inventaire'">
                    <label class="form-label">Entrepôt</label>
                    <div class="d-flex w-100">
                        <ng-select
                            id="entrepotSelectStock"
                            class="filter-ng-select flex-grow-1"
                            [items]="entrepots"
                            [searchable]="true"
                            [clearable]="true"
                            [loading]="isLoadingEntrepots"
                            placeholder="Choisissez un entrepôt"
                            [(ngModel)]="filters.entrepot_id"
                            (change)="updateFilteredData()"
                            bindValue="id">
                            <ng-template ng-option-tmp let-item="item">
                                {{ item.nom || item.libelle || item.code || item.code_entrepot || '--' }}
                            </ng-template>
                            <ng-template ng-label-tmp let-item="item">
                                {{ item?.nom || item?.libelle || item?.code || item?.code_entrepot || 'Choisissez un entrepôt' }}
                            </ng-template>
                        </ng-select>
                    </div>
                </div>

                <!-- Projet -->
                <div class="mb-1">
                    <label class="form-label">Projet</label>
                    <div class="d-flex w-100">
                        <ng-select
                            id="projetSelectStock"
                            class="filter-ng-select flex-grow-1"
                            [items]="projects"
                            [searchable]="true"
                            [clearable]="true"
                            [loading]="isLoadingProjects"
                            placeholder="Choisissez un projet"
                            [(ngModel)]="filters.projet_id"
                            (change)="onProjetFilterChange()"
                            bindValue="id">
                            <ng-template ng-option-tmp let-item="item">
                                {{ item.libelle || item.titre || '--' }}
                            </ng-template>
                            <ng-template ng-label-tmp let-item="item">
                                {{ item?.libelle || item?.titre || 'Choisissez un projet' }}
                            </ng-template>
                        </ng-select>
                    </div>
                </div>

                <!-- Montant -->
                <div class="mb-1">
                    <label class="form-label">Montant</label>
                    <div class="d-flex w-100">
                        <select class="form-select form-control flex-grow-1" [(ngModel)]="filters.operator">
                            <option value="=">=</option>
                            <option value=">">></option>
                            <option value="<"><</option>
                        </select>
                        <input type="number" class="form-control flex-grow-1" [(ngModel)]="filters.chiffre_aff"
                               style="margin-left: 12px;"/>
                    </div>
                </div>

                <!-- État -->
                <div>
                    <label class="form-label" style="margin-bottom: 8px">État</label>
                    <br>
                    <div *ngFor="let etat of statuses" 
                         class="containerType" 
                         [class.selected]="isStatusSelected(etat)"
                         (click)="toggleStatusFilter(etat)"
                         style="cursor: pointer;">
                        {{ etat }}
                    </div>
                </div>

                <!-- Dates -->
                <div class="mb-1 filter-date-container">
                    <div class="d-flex w-100" style="gap: 12px;">
                        <div class="flex-grow-1">
                            <label for="dateDuStock" class="form-label">Date de création</label>
                            <input #dateDuStock id="dateDuStock" type="text" class="form-control m-0" placeholder="du" 
                                   readonly
                                   style="cursor: pointer; background-color: white;"/>
                        </div>
                        <div class="flex-grow-1">
                            <label for="dateJusquaStock" class="form-label">Jusqu'à</label>
                            <input #dateJusquaStock id="dateJusquaStock" type="text" placeholder="Jusqu'à" 
                                   class="form-control m-0" 
                                   readonly
                                   style="cursor: pointer; background-color: white;"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pt-2 d-flex justify-content-end gap-1">
                <button class="btn btn-outline-secondary" (click)="resetFilters()" style="margin-right: 15px;">
                    Réinitialiser
                </button>
                <button class="btn btn-primary" (click)="applyFilters()">Appliquer</button>
            </div>
        </div>
    </div>
</div>

<div class="table-full-width">
    <div class="table-responsive" style="height: 640px">
        <table class="table table-hover" #table >
            <thead class="custom-header">
            <tr>
                <th *ngIf="type !== 'facture' || isFactureListColumnVisible('reference')"
                    style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 20%">RÉFÉRENCE</th>
                <th *ngIf="type !== 'facture' || isFactureListColumnVisible('date')"
                    style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 16%">DATE</th>
                <th *ngIf="type === 'avoir' || type === 'avoir-fournisseur'"
                    style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 14%">TYPE</th>
                <th *ngIf="(type !== 'bon-transfert' && type !== 'inventaire') && (type !== 'facture' || isFactureListColumnVisible('client'))"
                    style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 20%">
                    {{ baseRoute === '/vente' ? 'CLIENT' : 'FOURNISSEUR' }}
                </th>
                <th *ngIf="type === 'facture' && isFactureListColumnVisible('codeClient')"
                    style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 12%">CODE CLIENT</th>
                <th *ngIf="type === 'facture' && isFactureListColumnVisible('matricule')"
                    style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 14%">MATRICULE</th>
                <th *ngIf="type === 'facture' && isFactureListColumnVisible('nif')"
                    style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 12%">NIF</th>
                <th *ngIf="type === 'facture' && isFactureListColumnVisible('email')"
                    style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 14%">EMAIL</th>
                <th *ngIf="type === 'facture' && isFactureListColumnVisible('codeEtablissement')"
                    style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 12%">CODE ÉTABL.</th>
                <th *ngIf="type === 'facture' && isFactureListColumnVisible('codeEntrepot')"
                    style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 12%">CODE ENTREPÔT</th>
                <th *ngIf="type === 'inventaire'" style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 20%">
                    ENTREPÔT
                </th>
                <th *ngIf="type === 'bon-transfert'" style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 20%">Entrepôt initial</th>
                <th *ngIf="type === 'bon-transfert'" style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 20%">Entrepôt destination</th>
                <th *ngIf="type === 'facture' && isFactureListColumnVisible('ht')"
                    style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 12%">HT</th>
                <th *ngIf="type === 'facture' && isFactureListColumnVisible('tva')"
                    style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 12%">TVA</th>
                <th *ngIf="(type !== 'bon-transfert') && (type !== 'facture' || isFactureListColumnVisible('ttc'))"
                    style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 20%">TTC</th>
                <th *ngIf="type === 'facture' && isFactureListColumnVisible('timbreFiscal')"
                    style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 12%">TIMBRE</th>
                <th *ngIf="type === 'facture' && isFactureListColumnVisible('netPayer')"
                    style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 12%">NET À PAYER</th>
                <th *ngIf="type === 'facture' && isFactureListColumnVisible('dateLivraison')"
                    style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 14%">DATE LIVRAISON</th>
                <th *ngIf="type === 'facture' && isFactureListColumnVisible('note')"
                    style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 16%">NOTE</th>
                <th *ngIf="type === 'facture' && isFactureListColumnVisible('createdAt')"
                    style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 14%">CRÉÉ LE</th>
                <th *ngIf="type !== 'facture' || isFactureListColumnVisible('statut')"
                    style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 16%">STATUT</th>
                <th style="font-weight: 500; font-size: 13px; color: rgba(47, 43, 61, 0.9); width: 200px">ACTION</th>
            </tr>
            </thead>
            <tbody>
                <!-- Chargement : barre globale + squelette tableau -->
                <tr *ngIf="isTableLoading || (!hasDataLoaded && paginatedData.length === 0)">
                    <td [attr.colspan]="getTableColspan()" class="p-0 border-0">
                        <div class="erp-table-skeleton" *ngIf="isTableLoading">
                            <div class="erp-table-skeleton__row" *ngFor="let _ of skeletonRows">
                                <span class="erp-table-skeleton__cell erp-table-skeleton__cell--ref"></span>
                                <span class="erp-table-skeleton__cell"></span>
                                <span class="erp-table-skeleton__cell"></span>
                                <span class="erp-table-skeleton__cell erp-table-skeleton__cell--short"></span>
                                <span class="erp-table-skeleton__cell erp-table-skeleton__cell--badge"></span>
                                <span class="erp-table-skeleton__cell erp-table-skeleton__cell--actions"></span>
                            </div>
                        </div>
                    </td>
                </tr>

                <!-- Données (affichées seulement si pas en chargement et données chargées) -->
                <ng-container *ngIf="!isTableLoading && hasDataLoaded">
            <ng-container *ngFor="let item of paginatedData">

                <tr >
                    <td *ngIf="type !== 'facture' || isFactureListColumnVisible('reference')">
                        <a  class="ref d-flex align-items-center cursor-pointer hover-bg-light" (click)="showApercu(item)" style="cursor: pointer;"
                           [class.table-active]="selectedItem?.id === item.id">

                            {{ item.reference }}
                        </a>
                    </td>
                    <td *ngIf="type !== 'facture' || isFactureListColumnVisible('date')">{{ item.date | date: 'dd / MM / yyyy' }}</td>
                    <td *ngIf="type === 'avoir' || type === 'avoir-fournisseur'"
                        style="font-size: 13px; color: rgba(47, 43, 61, 0.85);">
                        {{ getDocumentTypeLabel(item) }}
                    </td>
                    <td *ngIf="(type !== 'bon-transfert' && type !== 'inventaire') && (type !== 'facture' || isFactureListColumnVisible('client'))">{{ getPartyName(item) }}</td>
                    <td *ngIf="type === 'facture' && isFactureListColumnVisible('codeClient')"
                        style="font-size: 13px;">{{ getFactureCodeClient(item) }}</td>
                    <td *ngIf="type === 'facture' && isFactureListColumnVisible('matricule')"
                        style="font-size: 13px;">{{ item.matricule || '—' }}</td>
                    <td *ngIf="type === 'facture' && isFactureListColumnVisible('nif')"
                        style="font-size: 13px;">{{ getFactureNif(item) }}</td>
                    <td *ngIf="type === 'facture' && isFactureListColumnVisible('email')"
                        style="font-size: 13px;">{{ getFactureEmail(item) }}</td>
                    <td *ngIf="type === 'facture' && isFactureListColumnVisible('codeEtablissement')"
                        style="font-size: 13px;">{{ getFactureCodeEtablissement(item) }}</td>
                    <td *ngIf="type === 'facture' && isFactureListColumnVisible('codeEntrepot')"
                        style="font-size: 13px;">{{ getFactureCodeEntrepot(item) }}</td>
                    <td *ngIf="type === 'inventaire'" style="font-size: 13px;">{{ getEntrepotInventaire(item) }}</td>
                    <td *ngIf="type === 'bon-transfert'" style="font-size: 13px;">{{ getEntrepotInitial(item) }}</td>
                    <td *ngIf="type === 'bon-transfert'" style="font-size: 13px;">{{ getEntrepotDestination(item) }}</td>
                    <td *ngIf="type === 'facture' && isFactureListColumnVisible('ht')"
                        style="font-size: 15px; font-weight: 500; color: rgba(47, 43, 61, 0.9);">
                        {{ item.totalHt || '0.000 TND' }}
                    </td>
                    <td *ngIf="type === 'facture' && isFactureListColumnVisible('tva')"
                        style="font-size: 15px; font-weight: 500; color: rgba(47, 43, 61, 0.9);">
                        {{ item.totalTva || '0.000 TND' }}
                    </td>
                    <td *ngIf="(type !== 'bon-transfert') && (type !== 'facture' || isFactureListColumnVisible('ttc'))"
                        style="font-size: 15px; font-weight: 500; color: rgba(47, 43, 61, 0.9);">
                        {{ item.revenue }}
                    </td>
                    <td *ngIf="type === 'facture' && isFactureListColumnVisible('timbreFiscal')"
                        style="font-size: 13px;">{{ item.timbreFiscal || '0.000 TND' }}</td>
                    <td *ngIf="type === 'facture' && isFactureListColumnVisible('netPayer')"
                        style="font-size: 13px;">{{ item.netPayer || '0.000 TND' }}</td>
                    <td *ngIf="type === 'facture' && isFactureListColumnVisible('dateLivraison')"
                        style="font-size: 13px;">{{ getFactureDateLivraison(item) }}</td>
                    <td *ngIf="type === 'facture' && isFactureListColumnVisible('note')"
                        style="font-size: 13px; max-width: 180px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                        [title]="getFactureNote(item)">{{ getFactureNote(item) }}</td>
                    <td *ngIf="type === 'facture' && isFactureListColumnVisible('createdAt')"
                        style="font-size: 13px;">{{ getFactureCreatedAt(item) }}</td>
                    <td *ngIf="type !== 'facture' || isFactureListColumnVisible('statut')">
        <div class="status-badge-wrapper">
          <span class="badge" [ngClass]="getItemStatusBadgeClass(item)">
            {{ getDisplayStatus(item) }}
          </span>
          <div class="status-popover" role="tooltip" *ngIf="getStatusesForPopover(item).length">
            <div class="status-popover-title">Statuts possibles</div>
            <ul class="status-popover-list">
              <li *ngFor="let s of getStatusesForPopover(item)" [class.current]="s === item.status">{{ s }}</li>
            </ul>
          </div>
        </div>
                    </td>
                    <td class="action-icons d-flex align-items-center">
                        <a class="me-2 action-icon"
                           (click)="editDocument(item); $event.preventDefault()"
                           title="Modifier le document"

                           style="color: rgba(47, 43, 61, 0.7); margin-right: 30px; width: 20px; height: auto">
                            <span data-feather="edit" [size]="20"></span>
                        </a>
                        <a class="me-2 action-icon"
                           (click)="openDetailModalForItem(item); $event.preventDefault()"
                           title="Aperçu du document"
                           style="color: rgba(47, 43, 61, 0.7); margin-right: 30px; width: 20px; height: auto">
                            <span data-feather="eye" [size]="20"></span>
                        </a>
                        <a class="me-2 action-icon"
                           *ngIf="type === 'facture'"
                           [class.disabled]="!hasTicketsConsolides(item)"
                           [style.pointer-events]="hasTicketsConsolides(item) ? 'auto' : 'none'"
                           [style.opacity]="hasTicketsConsolides(item) ? '1' : '0.5'"
                           [style.color]="hasTicketsConsolides(item) ? 'rgba(47, 43, 61, 0.7)' : 'rgba(128, 128, 128, 0.6)'"
                           [style.cursor]="hasTicketsConsolides(item) ? 'pointer' : 'not-allowed'"
                           (click)="hasTicketsConsolides(item) && openTicketsConsolides(item); $event.preventDefault()"
                           [title]="hasTicketsConsolides(item) ? 'Tickets consolidés' : 'Aucun ticket consolidé'"
                           style="margin-right: 30px; width: 20px; height: auto">
                            <span data-feather="git-merge" [size]="20"></span>
                        </a>
                        <a class="me-2 action-icon" 
                           *ngIf="type === 'facture' || type === 'facture-fournisseur' || type === 'retour-fournisseur' || type === 'avoir' || type === 'avoir-fournisseur'"
                           [class.disabled]="!shouldShowPaiementIcon(item)"
                           [style.pointer-events]="shouldShowPaiementIcon(item) ? 'auto' : 'none'"
                           [style.opacity]="shouldShowPaiementIcon(item) ? '1' : '0.5'"
                           [style.color]="shouldShowPaiementIcon(item) ? 'rgba(237, 144, 56, 1)' : 'rgba(128, 128, 128, 0.6)'"
                           (click)="shouldShowPaiementIcon(item) && openPaiementModal(item); $event.preventDefault()"
                           [title]="shouldShowPaiementIcon(item) ? 'Paiement de la facture' : 'Facture déjà payée'"
                           [style.cursor]="shouldShowPaiementIcon(item) ? 'pointer' : 'not-allowed'"
                           style="margin-right: 30px; width: 20px; height: auto;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                 class="bi bi-coin" viewBox="0 0 16 16">
                                <path d="M5.5 9.511c.076.954.83 1.697 2.182 1.785V12h.6v-.709c1.4-.098 2.218-.846 2.218-1.932 0-.987-.626-1.496-1.745-1.76l-.473-.112V5.57c.6.068.982.396 1.074.85h1.052c-.076-.919-.864-1.638-2.126-1.716V4h-.6v.719c-1.195.117-2.01.836-2.01 1.853 0 .9.606 1.472 1.613 1.707l.397.098v2.034c-.615-.093-1.022-.43-1.114-.9zm2.177-2.166c-.59-.137-.91-.416-.91-.836 0-.47.345-.822.915-.925v1.76h-.005zm.692 1.193c.717.166 1.048.435 1.048.91 0 .542-.412.914-1.135.982V8.518z"/>
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                <path d="M8 13.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11m0 .5A6 6 0 1 0 8 2a6 6 0 0 0 0 12"/>
                            </svg>
                        </a>
                        <a class="me-2 action-icon" *ngIf="type !== 'inventaire' && type !== 'bon-transfert' && type !== 'bon-sortie'"
                           [class.disabled]="isConvertDisabled(item)"
                           [style.pointer-events]="isConvertDisabled(item) ? 'none' : 'auto'"
                           [style.opacity]="isConvertDisabled(item) ? '0.5' : '1'"
                           [style.cursor]="isConvertDisabled(item) ? 'not-allowed' : 'pointer'"
                           [style.color]="isConvertDisabled(item) ? 'rgba(128, 128, 128, 0.6)' : 'rgba(19, 74, 211, 1)'"
                           (click)="!isConvertDisabled(item) && openConvertModal(item); $event.preventDefault()"
                           [title]="isConvertDisabled(item) ? 'Conversion non disponible pour ce statut' : 'Convertir le document'"
                           style="margin-right: 30px; width: 20px; height: auto">
                            <span data-feather="repeat" [size]="20"></span>
                        </a>

                        <div ngbDropdown container="body">
                            <a ngbDropdownToggle href="javascript:void(0);"
                               class="action-icon"
                               id="dropdownBrowserState{{item.reference}}"
                               aria-expanded="false"
                               style="color: rgba(47, 43, 61, 0.7); margin-top: 8px;">
                                <span data-feather="more-vertical" class="cursor-pointer" [size]="20"></span>
                            </a>
                            <div ngbDropdownMenu class="dropdown-menu-right"
                                 aria-labelledby="dropdownBrowserState{{item.reference}}">

                                <!-- Option PDF Aperçu -->
                                <a href="javascript:void(0)" ngbDropdownItem
                                   class="pdf-download-item"
                                   (click)="downloadApproveVentePDF(item); $event.preventDefault()"
                                   [disabled]="isExportingPDF">
                                    <span data-feather="file-text" class="mr-50" style="color: #134ad3;"></span>
                                    Télécharger
                                </a>

                                <div ngbDropdownDivider></div>

                                <!-- Autres options existantes -->
                                <a href="javascript:void(0)" ngbDropdownItem
                                   (click)="downloadPDF(); $event.preventDefault()"
                                   [disabled]="isExportingPDF">
                                    <span data-feather="file-text" class="mr-50"></span> PDF Tableau
                                </a>
                                <a href="javascript:void(0)" ngbDropdownItem
                                   (click)="openPhoneModal(item); $event.preventDefault()">
                                    <span data-feather="phone-call" class="mr-50"></span> Appeler
                                </a>
                                <a href="javascript:void(0)" ngbDropdownItem
                                   (click)="openSmsModal(item); $event.preventDefault()">
                                    <span data-feather="message-square" class="mr-50"></span> Envoyer un SMS
                                </a>
                                <a href="javascript:void(0)" ngbDropdownItem
                                   (click)="openEmailModal(item); $event.preventDefault()">
                                    <span data-feather="mail" class="mr-50"></span> Envoyer par email
                                </a>
                                <a href="javascript:void(0)" ngbDropdownItem
                                   (click)="duplicateDocument(item); $event.preventDefault()">
                                    <span data-feather="copy" class="mr-50"></span> Dupliquer
                                </a>
                                <a href="javascript:void(0)" ngbDropdownItem
                                   (click)="openImportModal(); $event.preventDefault()">
                                    <span data-feather="paperclip" class="mr-50"></span> Pièce jointe
                                </a>
                            </div>
                        </div>
                    </td>
                </tr>

            </ng-container>

            <tr *ngIf="paginatedData.length === 0 && !isTableLoading && hasDataLoaded">
                <td [attr.colspan]="getTableColspan()" class="text-center" style="padding: 3rem;">
                    <div class="d-flex flex-column align-items-center justify-content-center">
                        <p class="mb-0" style="text-align: center; font-weight: 700; color: #6e6e6e;font-size: 15px">
                            Pas de données à afficher
                        </p>
                    </div>
                </td>
            </tr>

                </ng-container>
            </tbody>
        </table>
    </div>
</div>

<div class="">
<div class="row d-flex pagination-bar">
    <div class="col-md-3 col-12">
        <div class="d-flex justify-content-between align-items-center">
            <label class="d-flex align-items-center" style="font-size: 15px; margin-left: 24px">
                Afficher
                <select class="form-control mx-25" [(ngModel)]="basicSelectedOption"
                        (ngModelChange)="updatePagination()">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
            </label>
        </div>
    </div>
    <div class="col-md-9 col-12 pagination-col">
        <div class="pagination-row d-flex justify-content-end gap-2">
            <div class="page-box" [class.disabled]="currentPage === 1" (click)="currentPage > 1 && changePage(1)">«
            </div>
            <div class="page-box" [class.disabled]="currentPage === 1"
                 (click)="currentPage > 1 && changePage(currentPage - 1)">‹
            </div>
            <div *ngFor="let page of pages" class="page-box" [class.active]="page === currentPage"
                 (click)="changePage(page)">{{ page }}
            </div>
            <div class="page-box" [class.disabled]="currentPage === totalPages"
                 (click)="currentPage < totalPages && changePage(currentPage + 1)">›
            </div>
            <div class="page-box" [class.disabled]="currentPage === totalPages"
                 (click)="currentPage < totalPages && changePage(totalPages)">»
            </div>
        </div>
    </div>
</div>
</div>
<div style="height: 110px"></div>
<!-- Redirect Modal after conversion -->
<ng-template #redirectModal let-modal>
    <div class="modal-header" style="background-color: transparent; border-bottom: none;">
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body d-flex flex-column align-items-center" style="padding: 30px 64px 64px;">

        <h4 class="mb-1" style="text-align: center; font-weight: 600;">Conversion réussie !</h4>
        <p class="mb-1" style="text-align: center; color: rgba(47, 43, 61, 0.7);font-size: 15px;font-weight: 500">
            Le document a été converti avec succès en <strong>{{ conversionResult?.newType }}</strong>.
        </p>
        <p class="mb-2" style="text-align: center; color: rgba(47, 43, 61, 0.7);font-size: 15px;font-weight: 500">
            Que souhaitez-vous faire ?
        </p>
        <div class="d-flex gap-3 justify-content-center" style="width: 100%;">
            <button type="button" 
                    class="btn"
                    (click)="stayOnCurrentPage(); modal.close()"
                    style="min-width: 150px;margin-right: 16px;background-color: rgba(128, 131, 144, 0.16)">
                Rester ici
            </button>
            <button type="button" 
                    class="btn btn-primary" 
                    (click)="redirectToNewPage(); modal.close()"
                    style="min-width: 150px;">
                Aller à {{ conversionResult?.newType }}
            </button>
        </div>
    </div>
</ng-template>

<!-- Phone Modal -->
<ng-template #phoneModal let-modal>
    <div class="modal-header" style="background-color: transparent;">
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body d-flex flex-column align-items-center">
        <p class="modal-title justify-content-center align-items-center"
           style="margin-right: 60px; margin-left: 60px; margin-bottom: 24px; font-size: 24px; font-weight: 500; text-align: center;">
            Numéros de téléphone
        </p>
        <ul class="phone-list">
            <li *ngFor="let phone of selectedItem?.phoneNumbers || []" class="d-flex align-items-center"
                style="margin-bottom: 24px;">
                <div class="d-flex align-items-center justify-content-center phone-container">
                    <button type="button" class="phone-button">
                        <a href="https://wa.me/{{ phone }}" target="_blank" class="whatsapp-icon"
                           title="Ouvrir WhatsApp" style="color: rgba(0, 162, 14, 0.9);">
                            <span data-feather="phone" class="phone-icon"></span>
                        </a>
                    </button>
                </div>
                <span class="phone-number"
                      style="color: rgba(47, 43, 61, 0.9); font-size: 18px; font-weight: 500; margin-left: 12px;">{{ phone }}</span>
            </li>
            <li *ngIf="!(selectedItem?.phoneNumbers?.length > 0)" class="text-center">Aucun numéro disponible</li>
        </ul>
    </div>
</ng-template>

<app-detail-vente #detailVente (downloadDocument)="onDownloadDocumentFromDetail($event)"></app-detail-vente>
<app-file-upload-modal #uploadModal></app-file-upload-modal>
<app-convert-modal #convertModal (conversionSuccess)="onConversionSuccess($event)"></app-convert-modal>
<app-paiement-facture #paiementFacture (paiementSuccess)="onPaiementSuccess($event)"></app-paiement-facture>
<app-sms-modal #smsModal></app-sms-modal>
<app-detail-cmd-fourniss #detailCommandeFournisseurModal></app-detail-cmd-fourniss>
<app-detail-inventaire #detailInventaireModal></app-detail-inventaire>

<app-apercue
        #apercueModal
        *ngIf="isApercuVisible"
        [selectedItem]="selectedItem"
        [documentTypeInput]="type">
</app-apercue>

<!-- Email Compose Component -->
<app-email-compose
    #emailCompose
    [documentId]="selectedItemForEmail?.id || null"
    [reference]="getEmailReference()"
    [date]="getEmailDate()"
    [total]="getEmailTotal()">
</app-email-compose>
